import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { utils } from '@enso/components';
import theme from '../../../theme';

const BannerContainer = styled.section`
  padding: 0;
  margin: 0;
  width: 100%;
  background-color: ${props => props.theme.color.backgroundWhite};
`;

const BannerLink = styled(Link)`
  display: block;
  width: 100%;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
  padding: 0;
`;

BannerContainer.defaultProps = { theme };

const InfoBanner = function() {
  return (
    <BannerContainer>
      <BannerLink to="/informacion_para_clientes">
        <BannerImage
          src="/images/banner-infcli2.webp"
          alt="Información importante para clientes"
        />
      </BannerLink>
    </BannerContainer>
  );
};

export default InfoBanner;
